import { JobPhase } from '@prisma/client';
import { titlifyEnum } from '@utils/stringHelpers';

export const getJobPhaseDisplayText = (jobPhase: JobPhase) => {
	switch (jobPhase) {
		case JobPhase.ESTIMATE:
			return 'Bid';
		case JobPhase.QUICK_ESTIMATE:
			return 'Bid';
		case JobPhase.WORK_ORDER:
			return 'Won Job';
		default:
			return titlifyEnum(jobPhase);
	}
};

/**
 * A total `Record` rather than a switch with a fallback, so a sixth `JobPhase` is a compile error instead
 * of a silently gray pill. `QUICK_ESTIMATE` is spelled as gray because that is what the fallback it
 * replaced gave it — the one entry nobody chose on purpose, and the one to revisit first.
 */
export const JOB_PHASE_BADGE_COLORS: Record<JobPhase, { background: string; border: string }> = {
	ESTIMATE: { background: 'bg-cyan-100 text-cyan-900', border: 'border-cyan-500' },
	JOB_COMPLETE: { background: 'bg-purple-200 text-purple-900', border: 'border-purple-500' },
	JOB_LOST: { background: 'bg-red-200 text-red-900', border: 'border-red-500' },
	QUICK_ESTIMATE: { background: 'bg-gray-100 text-gray-600', border: 'border-gray-500' },
	WORK_ORDER: { background: 'bg-green-200 text-green-900', border: 'border-green-500' },
};

/** Shared so a status that is not a `JobPhase` — the leads board's "Job Deleted" — is the same pill. */
export const JOB_PHASE_PILL_CLASS = 'inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium';

/** The phase on its own. `PhaseIdBadge` is the variant that prefixes it with the job id. */
export const JobPhaseBadge = ({ className = '', jobPhase }: { className?: string; jobPhase: JobPhase }) => {
	const colors = JOB_PHASE_BADGE_COLORS[jobPhase];

	return <span className={`${JOB_PHASE_PILL_CLASS} ${colors.background} ${colors.border} ${className}`}>{getJobPhaseDisplayText(jobPhase)}</span>;
};
